"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Header() {
    return (react_1.default.createElement("div", { className: "fixed-header" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "navbar-header" },
                react_1.default.createElement("button", { type: "button", className: "navbar-toggle" },
                    react_1.default.createElement("span", { className: "icon-bar" }),
                    react_1.default.createElement("span", { className: "icon-bar" }),
                    react_1.default.createElement("span", { className: "icon-bar" })),
                react_1.default.createElement("a", { className: "navbar-brand", href: "#" }, "Complete Bookkeeping & Tax Service")),
            react_1.default.createElement("nav", { className: "main-menu" },
                react_1.default.createElement("ul", { className: "dark-blue-text" },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#home" }, "Home")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#services" }, "Bookkeeping")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#payroll" }, "Payroll Processing")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#taxes" }, "Tax Preparation")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#consult" }, "Business Consulting")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#contact" }, "Contact")),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("a", { href: "#about" }, "About")))))));
}
exports.default = Header;
